import { t } from "@lingui/macro";
import { defaultSections } from "@reactive-resume/schema";
import { Label, Textarea } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";

import { useResumeStore } from "@/client/stores/resume";

import { SectionIcon } from "./shared/section-icon";
import { SectionOptions } from "./shared/section-options";

export const JobDescriptionSection = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const section = useResumeStore(
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (state) => state.resume.data.sections.jobDescription ?? defaultSections.jobDescription,
  );

  return (
    <section id="jobDescription" className="grid gap-y-6">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-x-4">
          <SectionIcon id="jobDescription" size={18} />
          <h2 className="line-clamp-1 text-2xl font-bold lg:text-3xl">{t`Job Description`}</h2>
        </div>

        <div className="flex items-center gap-x-2">
          <SectionOptions id="jobDescription" />
        </div>
      </header>

      <div className="mb-4 rounded-md bg-info/10 p-3 text-sm text-info">
        <p>
          {t`This is an optional field. You can fill this for AI generator and to record your resume for a specific job.`}
        </p>
      </div>

      <main className={cn("grid gap-6", !section.visible && "opacity-50")}>
        <div className="space-y-1.5">
          <Label htmlFor="jobDescription.description">{t`Job Description`}</Label>
          <Textarea
            id="jobDescription.description"
            rows={4}
            placeholder={t`Enter the job description here...`}
            value={section.description}
            onChange={(event) => {
              setValue("sections.jobDescription.description", event.target.value);
            }}
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="jobDescription.skillsRequired">{t`Skills Required`}</Label>
          <Textarea
            id="jobDescription.skillsRequired"
            rows={3}
            placeholder={t`Enter required skills...`}
            value={section.skillsRequired}
            onChange={(event) => {
              setValue("sections.jobDescription.skillsRequired", event.target.value);
            }}
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="jobDescription.responsibilities">{t`Responsibilities`}</Label>
          <Textarea
            id="jobDescription.responsibilities"
            rows={3}
            placeholder={t`Enter key responsibilities...`}
            value={section.responsibilities}
            onChange={(event) => {
              setValue("sections.jobDescription.responsibilities", event.target.value);
            }}
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="jobDescription.impact">{t`Impact`}</Label>
          <Textarea
            id="jobDescription.impact"
            rows={3}
            placeholder={t`Enter expected impact or outcomes...`}
            value={section.impact}
            onChange={(event) => {
              setValue("sections.jobDescription.impact", event.target.value);
            }}
          />
        </div>
      </main>
    </section>
  );
};

